import { GraphInfo } from "../../types/Graph/GraphInfo";
import api from "../../utils/api";
import { BULLETIN_INDICATOR_URL } from "../../utils/endpoints";

export async function getBulletinIndicator() {
  try {
    const response = await api.get(`${BULLETIN_INDICATOR_URL}`);
    const data: GraphInfo[] = response.data.value.map((option: GraphInfo) => ({
      id: option.id,
      createdAt: option.createdAt,
      indicator: option.indicator,
      graphicType: option.graphicType,
    }));
    return data;
  } catch (error) {
    throw error;
  }
}
